import { OFFER_TABLE_GET_SUCCESS, OFFER_TABLE_GET_FAILURE } from '../actions/types';
import offerTableConfig from '../configs';

/** @type {{config: object, placements: array.<object>}} */
const initialState = {
  config: offerTableConfig,
  data: [],
  metadata: {},
  isLoading: false,
  isLoaded: false,
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const offerTable = (state = initialState, action) => {
  switch (action.type) {
    case OFFER_TABLE_GET_SUCCESS: {
      const { response, metadata } = action.payload;

      return {
        ...state,
        data: response,
        metadata,
        isLoading: false,
        isLoaded: true,
      };
    }
    case OFFER_TABLE_GET_FAILURE: {
      return {
        ...state,
        data: [],
        metadata: {},
        isLoading: false,
        isLoaded: true,
      }; // we'd have to decide what to do with error state
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === OFFER_TABLE_GET_SUCCESS) {
        return { ...state, isLoading: true };
      }

      return state;
    }
  }
};

export default offerTable;
